module.exports = __webpack_public_path__ + "static/media/people.00285e28.svg";